import { useUserSession } from "@/hooks/useUserSession";
import { Alert, AlertIcon, Box, Text, CloseButton } from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const PromoBanner = () => {
  const { user } = useUserSession();
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(true);

  // Ne pas afficher si l'utilisateur n'est pas connecté
  if (!user) {
    return null;
  }

  // Ne pas afficher si l'utilisateur a déjà un plan premium
  if (user.currentPlan === "premium") {
    return null;
  }

  // Ne pas afficher après le 15 juillet 2025
  const expirationDate = new Date("2025-07-15");
  const currentDate = new Date();
  if (currentDate > expirationDate) {
    return null;
  }

  // Ne pas afficher si la bannière a été fermée
  if (!isVisible) {
    return null;
  }

  return (
    <Box position="relative">
      <Alert
        status="success"
        bgColor="#FFE4B5"
        color="#B8860B"
        borderColor="#DEB887"
        borderWidth="1px"
        justifyContent="center"
        py={3}
      >
        <AlertIcon color="#B8860B" />
        <Text fontWeight="medium" textAlign="center" flex="1">
          🌴 {t("promoBanner.message")}{" "}
          <Text as="strong" fontWeight="bold">
            {t("promoBanner.code")}
          </Text>
        </Text>
        <CloseButton
          position="absolute"
          right="8px"
          top="50%"
          transform="translateY(-50%)"
          onClick={() => setIsVisible(false)}
          color="#B8860B"
          _hover={{ color: "#8B7355" }}
        />
      </Alert>
    </Box>
  );
};

export default PromoBanner;
